import request from '@/utils/request'
import { sortItems } from '@/utils/genericUtils'


// DISABLED: bulk client list removed — use searchClientes or getClienteById instead
// const state = { listaClientes: [] }
// getters/mutations/actions for listaClientes removed

const state = {}
const getters = {}

const mutations = {}
const actions = {
    // getListaCli DISABLED: bulk load replaced by dynamic search (searchClientes)
    // async getListaCli({ commit, state, rootState }, payload) { ... }
    async searchClientes({ rootState }, { text, idSede }) {
        // Input validation
        if (!text || text.trim().length < 4) {
            return []
        }

        try {
            const { idBussines, id_role } = rootState.users.user

            const { data } = await request({
                url: `/ms/migraciones/v2.1/clientes/search?text=${encodeURIComponent(text)}&idSede=${idSede}`,
                method: 'GET',
                timeout: 5000 // 5 second timeout
            })

            // Return array of clients
            return data.data || []
        } catch (error) {
            console.error('Client search error:', error)
            return []
        }
    },
    async postCliente({ rootState }, payload) {
        const { idSede } = rootState.users.user

        const data = {
            ...payload,
            fecha_nacimiento: payload.fecha_nacimiento
        }

        const response = await request({
            url: '/api-loopback/tb_clientes',
            method: 'POST',
            headers: {
                'content-type': 'application/json'
                //
            },
            data
        })
        //console.log('POST_CLIENTE', response.data)
        return response.data
    },
    async patchClient({ rootState }, payload) {
        const sede = rootState.users.user.idSede
        const { full_name, telefono, direccion, correo, department_id, province_id, district_id, id } = payload
        console.log('payload_patchClient', payload)
        const { data } = await request({
            url: `/ms/migraciones/v2.0/persons?numeroDocumento=${payload.numeroDocumento}&idSede=${sede}`,
            method: 'PATCH',
            headers: {
                'content-type': 'application/json'
            },
            data: {
                name: full_name,
                telephone: telefono,
                address: direccion,
                email: correo,
                department_id,
                province_id,
                district_id,
                id
            }
        })
        console.log('data', data)
    },
    async getClient({ state, rootState }, payload) {
        const sede = rootState.users.user.idSede

        const { data } = await request({
            url: `/ms/migraciones/v2.0/persons?numeroDocumento=${payload}&idSede=${sede}`,
            method: 'GET',
            headers: {
                'content-type': 'application/json'
            }
        })
        console.log('data', data[0])
        if (data.length > 0) {
            return data[0]
        } else {
            return null
        }
    },
    async obtenerDataClient({ rootState }, payload) {
        let tipoDocumento = payload.length == 8 ? 'dni' : 'ruc'
        //console.log('tipoDocumento', tipoDocumento)
        const { data } = await request({
            url: `/ms/datosperu/v1.1/${tipoDocumento}/${payload}`,
            method: 'GET',
            headers: {
                'content-type': 'application/json'
            }
        })
        return tipoDocumento == 'dni' ? data.data.nombre_completo : data.data.nombre_o_razon_social
    },
    async createCliente({ rootState }, payload) {
        const { idSede, idBussines } = rootState.users.user

        const data = {
            ...payload,
            idBussines,
            idSede,
            fecha_nacimiento: payload.fecha_nacimiento
        }
        //console.log('data', data)
        const response = await request({
            url: '/api-orquestador/clientes/v2.0/kunte/create',
            method: 'POST',
            headers: {
                'content-type': 'application/json'
                //
            },
            data
        })
        //console.log('POST_CLIENTE', response.data)
        return response.data
    },
    async crearClienteFact({ rootState }, payload) {
        const { idSede, idBussines } = rootState.users.user
        console.log('payload', payload)
        //console.log('payload', payload)
        const response = await request({
            url: '/ms/migraciones/v2.0/clientes',
            method: 'POST',
            headers: {
                'content-type': 'application/json'
                //
            },
            data: { ...payload, idSede }
        })

        //console.log('POST_CLIENTE', response.data)
        return response.data
    },

    async enviarEmail({ rootState }, payload) {
        console.log('payload---', payload)
        const { emailClient, check_in, idSede, sedes, id, full_name, hourService } = payload
        const reservaSede = Object.values(sedes).find((v) => v.id == idSede)
        const { data } = await request({
            url: '/api-orquestador/email/v2.0/notificacion',
            method: 'POST',
            headers: {
                'content-type': 'application/json'
            },
            data: {
                email: emailClient,
                asunto: 'Confirmacion De Reserva',
                parametros: {
                    nombreCompletos: full_name,
                    serviceId: 3,
                    archivosAdjuntos: '',
                    id: id,
                    hourService,
                    fechaCreacion: check_in,
                    nombreSede: reservaSede.sede_name_id,
                    idSede: idSede
                }
            }
        })
        console.log('response', data)
        return data
    },

    async updateCliente({ rootState }, data) {
        const { idSede, idBussines } = rootState.users.user

        const response = await request({
            url: `/api-loopback/tb_clientes/updateCliPersona`,
            method: 'POST',
            headers: {
                'content-type': 'application/json'
                //
            },
            data
        })
        //console.log('POST_CLIENTE')
        //console.log(response.data)
    },
    async deleteClientes({ rootState }, payload) {
        // //console.log("GET_CLIENTE");
        const response = await request({
            url: `/api-loopback/tb_clientes/${payload.id}`,
            method: 'DELETE',
            headers: {
                'content-type': 'application/json'
                //
            }
        })
        //console.log('DELETE_CLIENTE')
        //console.log(response.data)
    },
    async getClienteExternal({ commit, state, rootState }, payload) {
        console.log('payload', payload)
        const tipodocumento = payload.idTipoDocumento == 1 ? 'dni' : 'ruc'
        const { data } = await request({
            url: `/api/${tipodocumento}/${payload.numeroDocumento}`,
            method: 'GET',
            headers: {
                'content-type': 'application/json'
            }
        })
        console.log('clientes_external_from_server', data.data)
        return data.data
    },

    async getClienteById({ rootState }, idCliente) {
        const { idSede } = rootState.users.user

        try {
            const { data } = await request({
                url: `/ms/migraciones/v2.0/persons/${idCliente}?idSede=${idSede}`,
                method: 'GET',
                headers: {
                    'content-type': 'application/json'
                }
            })
            console.log('cliente_by_id_fetched', data)
            const result = data.data
            // API returns array — take first element
            if (Array.isArray(result)) return result[0] || null
            return result || null
        } catch (error) {
            console.error('Error fetching client by ID:', error)
            return null
        }
    },

    async createClienteV2({ rootState }, payload) {
        const { idSede, idBussines } = rootState.users.user

        const data = {
            ...payload,
            idBussines,
            idSede
        }
        console.log('createClienteV2_payload', data)
        
        try {
            const response = await request({
                url: '/ms/migraciones/v2.0/clientes',
                method: 'POST',
                headers: {
                    'content-type': 'application/json'
                },
                data
            })
            console.log('createClienteV2_response', response.data)
            return response.data
        } catch (error) {
            console.error('Error creating client:', error)
            throw error
        }
    },

    async searchPersonByDoc({ rootState }, payload) {
        const { numDoc, idTipoDocumento, idSede } = payload

        try {
            const result = await this.dispatch('clientes/getClienteExternal', {
                numeroDocumento: numDoc,
                idTipoDocumento: idTipoDocumento
            })

            if (!result) {
                return {
                    success: false,
                    error: 'No se encontraron datos'
                }
            }

            // Map API response to component format
            // DNI API returns: nombre_completo, nombres, apellido_paterno, apellido_materno, direccion, direccion_completa, ubigeo: [dept_id, prov_id, dist_id]
            // RUC API returns: nombre_o_razon_social, direccion, ubigeo
            const mappedData = {
                name: result.nombre_completo || result.nombre_o_razon_social || result.name || '',
                address: result.direccion_completa || result.direccion || result.address || '',
                department_id: result.ubigeo && result.ubigeo[0] ? result.ubigeo[0] : null,
                province_id: result.ubigeo && result.ubigeo[1] ? result.ubigeo[1] : null,
                district_id: result.ubigeo && result.ubigeo[2] ? result.ubigeo[2] : null
            }

            return {
                success: true,
                data: mappedData
            }
        } catch (error) {
            console.error('Error searching person by doc:', error)
            return {
                success: false,
                error: error.message
            }
        }
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
